export * from "modules/HoldingAppointmentDetails/components/AppointmentStatus";
export * from "modules/HoldingAppointmentDetails/components/CarDetails";
export * from "modules/HoldingAppointmentDetails/components/Checks";
export * from "modules/HoldingAppointmentDetails/components/IndicatorsAction";
export * from "modules/HoldingAppointmentDetails/components/Interventions";
